module.exports = __webpack_public_path__ + "static/img/about01-jpa.9022e0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about01-jpa.png
// module id = /UTg
// module chunks = 1